<template>
  <div>
    <!-- <header class="blue accent-3 relative nav-sticky d-none d-md-block d-lg-block d-xl-block">
      <div class="container-fluid text-white">
        <div class="row p-t-b-10">
          <div class="col" style="margin-left: 20px; margin-top: 10px;">
            <h4>
              {{title}}
            </h4>
          </div>
        </div>
      </div>
    </header> -->
    <div>
      <b-navbar  class="brand-purple accent-3" toggleable type="dark">
        <b-navbar-brand>{{title}}</b-navbar-brand>

        <b-navbar-toggle target="navbar-toggle-collapse-admin" class="d-lg-none">
          <template v-slot:default="{ expanded }">
            <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
            <b-icon v-else icon="chevron-bar-down"></b-icon>
          </template>
        </b-navbar-toggle>


        <b-collapse id="navbar-toggle-collapse-admin" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="#" @click="home">
              <b-icon-house-door font-scale="1.5" class="sidebar-icon mr-2"></b-icon-house-door><span> Home</span>
            </b-nav-item>
            <br />
            <p class="text-white">Profile</p>
            <b-nav-item href="#" @click="profile">
              <b-icon-person font-scale="1.7" class="sidebar-icon mr-2"></b-icon-person><span>Profile</span>
            </b-nav-item>
            <b-nav-item href="#" @click="signOut">
              <b-icon-power font-scale="1.5" class="sidebar-icon mr-2"></b-icon-power><span>Log Out</span>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
  // import AmplifyStore from "../../store/store"
  import { Auth } from 'aws-amplify'

  export default {
    name: "Header",
    props: ['title'],
    data() {
      return {
        isAdmin: false
      }
    },
    methods: {
      home: function () {
        this.$router.push('/')
      },
      inbox: function () {
        this.$router.push('/inbox')
      },
      subscribers: function () {
        this.$router.push('/subscribers')
      },
      users: function () {
        this.$router.push('/users')
      },
      campaigns: function () {
        this.$router.push('/campaigns')
      },
      keywords: function () {
        this.$router.push('/key-words')
      },
      lists: function () {
        this.$router.push('/lists')
      },
      profile: function () {
        this.$router.push('/profile')
      },
      settings: function() {
        this.$router.push('/settings')
      },
      billing: function() {
        if (localStorage.stripeCustomerId) {
          axios.get(Constants.API_URL + '/stripe/billing?customerId=' + localStorage.stripeCustomerId)
            .then(response => {
              if (response.data.url) {
                window.location.href = response.data.url
              }
            }).catch(err => {
              console.error(err)
            })
        } else {
          this.$router.push('/plans')
        }
      },
      async signOut() {
        await Auth.signOut()
        window.location.href = '/'
      },
    },
    mounted() {
      Auth.currentAuthenticatedUser()
        .then(user => {
          user.signInUserSession.accessToken.payload['cognito:groups'].forEach(role => {
            if (role == "admin" || role == "owner") { 
              this.isAdmin = true 
            }
          })
        }).catch(err => {
          console.log(err)
        })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue